module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-row flex items-start justify-between-l justify-around flex-mobile-col w-100 lh-copy"
  }, [_c('plan-toggle-card', {
    attrs: {
      "onClick": _vm.setAkkoPlan,
      "selected": !_vm.isPhoneOnly,
      "type": "AKKO",
      "includeOpen": _vm.includeOpen,
      "toggleInclude": _vm.toggleInclude
    }
  }), _vm._v(" "), _c('plan-toggle-card', {
    attrs: {
      "onClick": _vm.setPhonePlan,
      "selected": _vm.isPhoneOnly,
      "type": "PHONE",
      "includeOpen": _vm.includeOpen,
      "toggleInclude": _vm.toggleInclude
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd189ca0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/PlanSelectToggle3c.vue
// module id = 783
// module chunks = 0